__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "adaptativo";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@juggle/resize-observer", "3.4.0", () => (__webpack_require__.e(564).then(() => (() => (__webpack_require__(44564))))));
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (__webpack_require__.e(191).then(() => (() => (__webpack_require__(28191))))));
			register("@plurall/reader", "3.0.47", () => (__webpack_require__.e(243).then(() => (() => (__webpack_require__(43624))))));
			register("@sentry/react", "7.119.1", () => (__webpack_require__.e(341).then(() => (() => (__webpack_require__(14722))))));
			register("@stitches/react", "1.2.8", () => (__webpack_require__.e(726).then(() => (() => (__webpack_require__(33345))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(710).then(() => (() => (__webpack_require__(26710))))));
			register("crypto-js", "4.2.0", () => (__webpack_require__.e(396).then(() => (() => (__webpack_require__(21396))))));
			register("dompurify", "3.3.3", () => (__webpack_require__.e(418).then(() => (() => (__webpack_require__(99418))))));
			register("graphql-tag", "2.12.6", () => (__webpack_require__.e(516).then(() => (() => (__webpack_require__(2135))))));
			register("graphql", "15.10.2", () => (__webpack_require__.e(883).then(() => (() => (__webpack_require__(32883))))));
			register("jsencrypt", "3.5.4", () => (__webpack_require__.e(77).then(() => (() => (__webpack_require__(64458))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("querystring", "0.2.1", () => (__webpack_require__.e(186).then(() => (() => (__webpack_require__(47186))))));
			register("react-beautiful-dnd", "13.1.1", () => (__webpack_require__.e(87).then(() => (() => (__webpack_require__(91468))))));
			register("react-device-detect", "1.17.0", () => (__webpack_require__.e(804).then(() => (() => (__webpack_require__(15042))))));
			register("react-dom", "18.3.1", () => (__webpack_require__.e(342).then(() => (() => (__webpack_require__(40961))))));
			register("react-loading-skeleton", "3.5.0", () => (__webpack_require__.e(636).then(() => (() => (__webpack_require__(70255))))));
			register("react-router-dom", "6.30.3", () => (__webpack_require__.e(267).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};